import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { CustomCheckBox, FormLabels, CustomCol } from 'src/components'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { isPropertyOfClimatetradeSelector, setProjectFormItemValue } from 'src/features'

const PropertyOfClimatetrade: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isPropertyOfCT = useAppSelector(isPropertyOfClimatetradeSelector)
  const { width } = useWindowSize()
  const isMobile = width < 800

  const handleChange = (value: boolean) => {
    dispatch(setProjectFormItemValue({ key: 'is_property_of_climatetrade', value }))
  }

  return (
    <Row>
      <CustomCol>
        <FormLabels
          title={t('Projects.Form.Ownership')}
          subtitle={t('Projects.Form.OwnershipLabel')}
        />
      </CustomCol>

      <CustomCol className={!isMobile ? 'mt-4' : 'mb-4'}>
        <CustomCheckBox
          defaultValue={isPropertyOfCT}
          text={t('Projects.Form.OwnershipCheckboxLabel')}
          handleChange={handleChange}
          isSmallText
        />
      </CustomCol>
    </Row>
  )
}

export default PropertyOfClimatetrade
